import { Box, createTheme, CssBaseline, PaletteOptions, ThemeProvider } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import About from "./components/about/About";
import Career from "./components/careers/Career";
import ContractManagement from "./components/contractManagement/ContractManagement";
import Home from "./components/home/Home";
import Footer from "./components/layout/Footer";
import Header from "./components/layout/Header";
import RegistrationForm from "./components/home/RegisterForm";
import { designTokens } from "./theme/designTokens";
import Services from "./components/services/Services";

// Re-export so tokens are discoverable from App.tsx entry point
export { designTokens } from "./theme/designTokens";
export { heroSlides, whatWeDoCards, technologyServices, clmFeatures, stats, aboutCopy, footerContent } from "./theme/homeContent";

const { colors, fonts, fontSizes, borderRadius } = designTokens;

const paletteOptions: PaletteOptions = {
  mode: "light",
  primary: {
    main: colors.primary,
    contrastText: colors.white,
  },
  secondary: {
    main: colors.secondary,
  },
  text: {
    primary: colors.textPrimary,
    secondary: colors.textSecondary,
  },
  background: {
    default: colors.background,
    paper: colors.background,
  },
};

const themeOptions = {
  palette: paletteOptions,
  typography: {
    fontFamily: fonts.family,
    h2: { fontWeight: fonts.weights.bold },
    h3: { fontWeight: fonts.weights.bold },
    h4: { fontWeight: fonts.weights.bold },
    h5: { fontWeight: fonts.weights.bold },
    h6: { fontWeight: fonts.weights.semibold },
    body1: { fontSize: fontSizes.base },
    body2: { fontSize: fontSizes.base, fontWeight: fonts.weights.regular },
    button: {
      fontWeight: fonts.weights.bold,
      textTransform: "uppercase" as const,
      fontSize: fontSizes.button,
    },
  },
  shape: {
    borderRadius: parseInt(borderRadius.md),
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: borderRadius.lg },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: borderRadius.sm,
          fontWeight: fonts.weights.bold,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { borderRadius: 0 },
      },
    },
  },
};

function App() {
  const themeConfig = createTheme(themeOptions);
  return (
    <ThemeProvider theme={themeConfig}>
      <Box>
        <CssBaseline />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contract-management" element={<ContractManagement />} />
          <Route path="/career" element={<Career />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/register" element={<RegistrationForm />} />
        </Routes>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;
